import { ModalIsland, Button } from "@saviynt/design-system";
import { FormattedMessage, useIntl } from "react-intl";
import { ModalOverlay } from "./ModalOverlay";

export default function DeleteCorrelationRuleModal({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
}: {
  isOpen: boolean;
  onClose: (open: boolean) => void;
  onConfirm: () => void;
  isDeleting: boolean;
}) {
  const intl = useIntl();
  return (
    <>
      {isOpen && <ModalOverlay onClick={() => onClose(false)} />}
      <ModalIsland
        kind="critical"
        alertTitle={intl.formatMessage({
          defaultMessage: "Are you sure?",
          id: "2oCaym",
        })}
        alertSubtitle={intl.formatMessage({
          defaultMessage: "This action will remove this correlation rule",
          id: "z6tU3X",
        })}
        onClose={onClose}
        isOpen={isOpen}
        className="!z-[10000]"
        primaryButton={
          <Button
            type="button"
            kind="outlined"
            isLoading={isDeleting}
            onClick={onConfirm}
          >
            {isDeleting ? (
              <FormattedMessage defaultMessage="Deleting..." id="noZdV2" />
            ) : (
              <FormattedMessage defaultMessage="Delete" id="K3r6DQ" />
            )}
          </Button>
        }
        secondaryButton={
          <Button type="button" kind="ghost" onClick={() => onClose(false)}>
            <FormattedMessage defaultMessage="Cancel" id="47FYwb" />
          </Button>
        }
      />
    </>
  );
}
